// POST method implementation:
const tenantID = Shopify.shop;
if (typeof boostSDCustomThemeConfig === "undefined") {
  boostSDCustomThemeConfig = false;
  document.querySelector(".boost-sd-custom-recommendation").classList.add("boost-sd-hidden");
}
if (
  typeof boostSDCustomThemeConfig !== "undefined" &&
  boostSDCustomThemeConfig &&
  boostSDCustomThemeConfig.custom.widgetID !== "" &&
  boostSDRecommendationConfig
) {



  
  const widgetID = boostSDCustomThemeConfig.custom.widgetID;
  const recommendationType = boostSDRecommendationConfig.widgets.collection[widgetID].params.recommendationType;
  const limit = boostSDRecommendationConfig.widgets.collection[widgetID].params.limit;
  const tag = "filter-collect:" + boostSDAppConfig.generalSettings.collection_id;
  let tagFilter = ['boost-sd--display'];
  if (boostSDAppConfig.generalSettings.collection_id !== 0) {
    tagFilter = [tag]; // string array
  }
  if (boostSDAppConfig.generalSettings.collection_id === 278074753180) {
    tagFilter.push('Coming Soon');
  }
  console.log(tagFilter)
  async function postData(url = "", data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }
  var params = {
    shop: tenantID, // tenant ID
    recommendationType: recommendationType, //  |ALL TYPES:  'bestsellers' 'newest-arrivals' 'frequently-bought-together' 'trending-products' 'hand-picked-products' 'recently-viewed' 'most-viewed' 'related-items';
    limit: limit, // number of products to return - maximum is 30
    wid: widgetID,
    productIds: [], // ID of product for get the related products. This field is only needed if the type is "related-items".
    locale: Shopify.locale, // language that has been declared in shopify admin
    pg: "product-page", // ALL PAGEs: 'home-page', 'collection-page', 'search-page','cart-page','product-page'
    tags: tagFilter,
  };
  postData("https://services.mybcapps.com/discovery/recommend", params).then((data) => {
    if (data && data.products && data.products.length > 0) {
      let html = "";
      for (const product of data.products) {
        html += buildProductTemplate(product);
      }
      document.querySelector(".boost-sd-custom-recommendation."+boostSDCustomThemeConfig.custom.widgetID+" .swiper-wrapper").innerHTML = html;
      document
        .querySelector(".boost-sd-custom-recommendation."+boostSDCustomThemeConfig.custom.widgetID+" .boost-sd__recommendation-title")
        .classList.remove("boost-sd-hidden"); //swiper-button-next boost-sd-hidden
      document.querySelector(".boost-sd-custom-recommendation."+boostSDCustomThemeConfig.custom.widgetID+" .swiper-button-next").classList.remove("boost-sd-hidden"); //swiper-button-next boost-sd-hidden
      document.querySelector(".boost-sd-custom-recommendation."+boostSDCustomThemeConfig.custom.widgetID+" .swiper-button-prev").classList.remove("boost-sd-hidden"); //swiper-button-next boost-sd-hidden
      //boost-sd-custom-recommendation
      if (boostSDAppConfig) {
        boostSDAppConfig.analytics = {
          selectorAddToCart: '.boost-sd__btn-add-to-cart, form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] *[name="add"], button.relative.w-full.uppercase.button-primary[aria-label="add to cart"]',
          selectorBuyNow: 'boost-sd__btn-buy-now, .shopify-payment-button__button, .shopify-payment-button, #dynamic-checkout-cart'
        };
      }
    } else {
      document.querySelector(".boost-sd-custom-recommendation."+boostSDCustomThemeConfig.custom.widgetID+"").classList.add("boost-sd-hidden");
    }
  });

  function buildProductTemplate(data) {
    // console.log(data)
    const judgeme = data.metafields.find(m => m.namespace === 'judgeme' && m.key === 'badge');
    let template = `

    <div class="swiper-slide">
      <product-card class="product-card text-center">
        <figure class="product-featured-image ${data.images_info.length > 1 ? "thb-hover" : ""}">
          <a href="/collections/${boostSDAppConfig.generalSettings.collection_handle}/products/${data.handle}" title="${
      data.title
    }" class="product-featured-image-link aspect-ratio aspect-ratio--adapt" style="--padding-bottom: 100%;">
          ${
            data.images_info.length > 1
              ? `<img class="product-secondary-image lazyload no-blur retina_size" width="${data.images_info[1].width}" height="${data.images_info[1].height}" data-sizes="auto" src="${data.images_info[1].src}" data-srcset="${data.images_info[1].src}" fetchpriority="auto" alt="${data.images_info[1].alt}" style="object-position: 50.0% 50.0%;"/>`
              : ""
          }
          <img class="product-primary-image lazyload no-blur retina_size" width="${
            data.images_info[0].width
          }" height="${data.images_info[0].height}" data-sizes="auto" src="${data.images_info[0].src}" data-srcset="${
      data.images_info[0].src
    }" fetchpriority="auto" alt="${data.images_info[0].alt}" style="object-position: 50.0% 50.0%;"/>
      
          </a>
          ${
            boostSDCustomThemeConfig.custom.enable_quick_view
              ? ` <quick-view class="boost-sd__btn-add-to-cart product-card-quickview product-card-quickview--button" href="#Product-Drawer" data-product-handle="${data.handle}" tabindex="-1">
              <div class="loading-overlay">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                      <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle>
                  </svg>
              </div>
              <span class="boost-sd__btn-add-to-cart">${boostSDCustomThemeConfig.custom.quick_view}</span>
          </quick-view>`
              : ``
          }
      
        </figure>
      	<div class="product-card-info">
          	<a href="/collections/${boostSDAppConfig.generalSettings.collection_handle}/products/${data.handle}" title="${
      data.title
    }" class="product-card-title">${data.title}</a>
             ${renderPrice(data)}
             <div class='jdgm-widget jdgm-preview-badge'>
              ${typeof judgeme !== 'undefined' ? judgeme.value : ''}
            </div>
          </div>
      </product-card>
    </div>
  `;
    return template;
  }

  function renderPrice(product) {
    let target, compare_at_price, price, available, money_price;
    const price_varies = product.price_min < product.price_max;
    const compare_at_price_varies =
      product.compare_at_price_min &&
      product.compare_at_price_max &&
      product.compare_at_price_min < product.compare_at_price_max;
    const sale_badge_type = boostSDCustomThemeConfig.custom.sale_badge_type;
    let show_badges = true;

    if (product.tags.includes("Kit") || product.tags.includes("nomarkdown")) {
      target = product;

      compare_at_price = target.compare_at_price_min;
      price = target.price_min || 1999;
      available = target.available || false;
      money_price = formatMoney(price);

      if (target === product && price_varies) {
        money_price = boostSDCustomThemeConfig.custom.from_price_html.replace(/{{ price }}/g, formatMoney(price));
      }
    } else {
      target = product;

      compare_at_price = target.compare_at_price_min;
      price = target.price_min || 1999;
      price = Math.round((price * 75).toFixed(1)) / 100;
      available = target.available || false;
      money_price = formatMoney(price);

      if (target === product && price_varies) {
        money_price = boostSDCustomThemeConfig.custom.from_price_html.replace(/{{ price }}/g, formatMoney(price));
      }
    }

    let html = "";

    html += '<span class="price">';

    if (!(price_varies === false && compare_at_price_varies)) {
      if (compare_at_price !== null && compare_at_price !== 0 && price !== compare_at_price) {
        html += `<del><span class="amount">${formatMoney(compare_at_price)}</span><br></del>`;
      }
    }

    html += `<ins><span class="amount">As low as ${money_price}</span></ins>`;

    if (show_badges) {
      let badgesHtml = `<span class="badges">`;

      if (compare_at_price > price) {
        let saved_amount = "";

        if (sale_badge_type === "save_amount") {
          saved_amount = formatMoney(compare_at_price - price);
        } else if (sale_badge_type === "save_percentage") {
          saved_amount = (((compare_at_price - price) / compare_at_price) * 100).toFixed(0) + "%";
        }

        badgesHtml += `<span class="badge onsale top left">`;
        if (sale_badge_type === "sale") {
          badgesHtml += boostSDCustomThemeConfig.custom.on_sale;
        } else {
          badgesHtml += boostSDCustomThemeConfig.custom.save_html.replace(/{{ saved_amount }}/g, saved_amount);
        }

        badgesHtml += `</span>`;
      }

      if (available === false) {
        badgesHtml += `<span class="badge out-of-stock top left">${boostSDCustomThemeConfig.custom.sold_out}</span>`;
      }
      let preorderMeta = product.metafields.find((m) => m.namespace === "theme" && m.key === "preorder");
      if (typeof preorderMeta !== "undefined" && product.available) {
        console.log(preorderMeta);
        badgesHtml += `<span class="badge pre-order top left">${boostSDCustomThemeConfig.custom.pre_order}</span>`;
      }

      badgesHtml += `</span>`;
      html += badgesHtml;
    }
    html += "</span>";
    return html;
  }

  function formatMoney(money, format, withoutTrailingZeros) {
    if (typeof format == "undefined") format = boostSDAppConfig.shop.money_format;
    if (format == "money_with_currency") format = boostSDAppConfig.shop.money_format_with_currency;
    if (typeof withoutTrailingZeros == "undefined") var withoutTrailingZeros = false;
    // if (typeof Shopify.formatMoney === 'function') { return Shopify.formatMoney(money, format); }
    if (typeof money == "string") {
      money = money.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || "${{amount}}";

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = parseFloat(number).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var money = parts[1] ? decimal + parts[1] : "";
      return withoutTrailingZeros == true ? (dollars + money).replace(/((\,00)|(\.00))$/g, "") : dollars + money;
    }

    var matches = formatString.match(placeholderRegex);
    var match = matches && matches.length > 1 ? matches[1] : "";
    switch (match) {
      case "amount":
        value = formatWithDelimiters(money, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(money, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(money, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(money, 0, ".", ",");
        break;
      case "amount_with_space_separator_no_comma":
        value = formatWithDelimiters(money, 2);
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(money, 0, " ", ".");
        break;
      default:
        value = formatWithDelimiters(money, 2);
        break;
    }
    formatString = formatString.replace(placeholderRegex, value);

    return formatString;
  }



  
} else {
  document.querySelector(".boost-sd-custom-recommendation").classList.add("boost-sd-hidden");
}
